import { formatPhoneNumber as libraryFormatPhoneNumber } from '@jjvgaming/player-payback-library'

export const formatPhoneNumber = (
  phone: number | string | undefined | null
): string => libraryFormatPhoneNumber(phone) ?? '-'
